export const Alignments = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  METRO: 'metro',
} as const;

type ObjectValues<T> = T[keyof T];
export type Alignments = ObjectValues<typeof Alignments>;
